/*
 * Gift Box Builder v3
 * Allows customers to group cart items into gift boxes
 */

(function() {
    // Configuration
    const CONFIG = {
        maxCapacity: 25,
        warningThreshold: 21,
        defaultCapacity: 3,
        giftServiceVariantId: '56334461534539',
        excludedProductTypes: ['Service', 'Premade gift'],
        storageKey: 'ribboniGiftBoxes'
    };

    // State
    let giftBoxModeActive = false;
    let boxAssignments = {};
    let boxCount = 0;
    let hasOverCapacity = false;

    // ============ INITIALIZATION ============

    function init() {
        const cartForm = document.getElementById('cart');
        if (!cartForm) return;

        loadState();

        validateStateOnLoad().then(function() {
            createToggleButton();
            createCheckoutCheckboxes();
            createCartNoteInput();
            interceptCheckoutButton();

            if (giftBoxModeActive) {
                activateGiftBoxMode();
            }

            updateCheckoutButtonState();

            console.log('Gift Box Builder initialized');
        });
    }

    // ============ STATE MANAGEMENT ============

    function saveState() {
        const state = {
            active: giftBoxModeActive,
            assignments: boxAssignments,
            boxCount: boxCount
        };
        localStorage.setItem(CONFIG.storageKey, JSON.stringify(state));
    }

    function loadState() {
        const saved = localStorage.getItem(CONFIG.storageKey);
        if (saved) {
            const state = JSON.parse(saved);
            giftBoxModeActive = state.active || false;
            boxAssignments = state.assignments || {};
            boxCount = state.boxCount || 0;
        }
    }

    function clearState() {
        giftBoxModeActive = false;
        boxAssignments = {};
        boxCount = 0;
        localStorage.removeItem(CONFIG.storageKey);
    }

    function validateStateOnLoad() {
        if (!giftBoxModeActive || boxCount === 0) {
            return Promise.resolve();
        }

        return fetch('/cart.js')
            .then(function(res) { return res.json(); })
            .then(function(cart) {
                const hasCGS = cart.items.some(function(item) {
                    return item.variant_id.toString() === CONFIG.giftServiceVariantId;
                });

                if (!hasCGS) {
                    clearState();
                }
            });
    }

    // ============ UI CREATION ============

    function createToggleButton() {
        const titleWrapper = document.querySelector('.title-wrapper-with-link');
        if (!titleWrapper) return;

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'gift-box-toggle-btn';
        button.textContent = giftBoxModeActive ? 'Cancel Gift Box' : 'Create Gift Box';
        if (giftBoxModeActive) button.classList.add('active');
        button.addEventListener('click', toggleGiftBoxMode);

        titleWrapper.insertAdjacentElement('afterend', button);
    }

    function createBoxDropdown(unitId, currentBox) {
        const select = document.createElement('select');
        select.className = 'gift-box-dropdown';
        select.dataset.unitId = unitId;

        updateDropdownOptions(select, currentBox);

        select.addEventListener('change', handleBoxSelection);
        return select;
    }

    function updateDropdownOptions(select, currentBox) {
        let html = '';

        if (currentBox && currentBox > 0) {
            // Item is assigned — show current box, other existing boxes, and remove
            for (let i = 1; i <= boxCount; i++) {
                const selected = currentBox === i ? 'selected' : '';
                html += `<option value="${i}" ${selected}>Box #${i}</option>`;
            }
            html += '<option value="0">Remove from box</option>';
        } else {
            // Item is unassigned — show all available boxes + new box option
            html += '<option value="0" selected>No box</option>';
            for (let i = 1; i <= boxCount; i++) {
                html += `<option value="${i}">Box #${i}</option>`;
            }
            if (boxCount < 3) {
                html += '<option value="new">+ New Box</option>';
            }
        }

        select.innerHTML = html;
    }

    function updateAllDropdowns() {
        const dropdowns = document.querySelectorAll('.gift-box-dropdown');
        dropdowns.forEach(function(select) {
            const unitId = select.dataset.unitId;
            const currentBox = boxAssignments[unitId] || 0;
            updateDropdownOptions(select, currentBox);
        });
    }

    function updateCapacityWarning(boxCapacities) {
      // Remove old warning element if exists
      const existingWarning = document.querySelector('.gift-box-capacity-warning');
      if (existingWarning) existingWarning.remove();

      // Check if any box exceeds capacity
      hasOverCapacity = Object.values(boxCapacities).some(function(cap) {
          return cap >= CONFIG.maxCapacity;
      });

      // Update checkout button state
      updateCheckoutButtonState();
    }

    function createCheckoutCheckboxes() {
      const checkoutBtn = document.querySelector('#checkout');
      if (!checkoutBtn) return;

      const checkoutWrapper = checkoutBtn.closest('.cart__ctas') || checkoutBtn.parentElement;
      if (!checkoutWrapper) return;

      // Check if checkboxes already exist
      if (document.querySelector('.checkout-checkboxes')) return;

      // Create container
      const container = document.createElement('div');
      container.className = 'checkout-checkboxes';

      // Terms checkbox (always visible)
      container.innerHTML = `
          <label class="checkout-checkbox-wrapper">
              <input type="checkbox" id="terms-checkbox" class="checkout-checkbox">
              <span>I agree to the <a href="/policies/terms-of-service" target="_blank">Terms and Conditions</a></span>
          </label>
          <label class="checkout-checkbox-wrapper cgs-checkbox-wrapper" style="display: none;">
              <input type="checkbox" id="cgs-checkbox" class="checkout-checkbox">
              <span>I agree that the Custom Gift Service begins immediately and that I lose my right of withdrawal once performed. See <a href="/policies/refund-policy" target="_blank">Refund Policy</a>.</span>
          </label>
      `;

      checkoutWrapper.insertBefore(container, checkoutBtn);

      // Add event listeners
      document.getElementById('terms-checkbox').addEventListener('change', updateCheckoutButtonState);
      document.getElementById('cgs-checkbox').addEventListener('change', updateCheckoutButtonState);

      // Check for CGS in cart
      updateCGSCheckboxVisibility();
    }

    function createCartNoteInput() {
        const cartItems = document.querySelector('.cart-items');
        if (!cartItems) return;

        // Check if already exists
        if (document.querySelector('.user-cart-note-wrapper')) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'user-cart-note-wrapper';

        const label = document.createElement('label');
        label.className = 'user-cart-note-label';
        label.setAttribute('for', 'user-cart-note');
        label.textContent = 'Order notes';

        const textarea = document.createElement('textarea');
        textarea.id = 'gift-box-user-note';
        textarea.className = 'user-cart-note';
        textarea.rows = 3;

        // Prevent change event from bubbling into <cart-items>,
        // which would try to validate this as a quantity input
        textarea.addEventListener('change', function(e) {
            e.stopPropagation();
        });

        wrapper.appendChild(label);
        wrapper.appendChild(textarea);

        cartItems.insertAdjacentElement('afterend', wrapper);

        updateCartNotePlaceholder();
    }

    function updateCartNotePlaceholder() {
        const textarea = document.getElementById('gift-box-user-note');
        if (!textarea) return;

        if (giftBoxModeActive && boxCount > 0) {
            textarea.placeholder = 'Gift boxes may include dried fruit, decorative elements, aroma from scented oils, and other fillers. If you prefer certain items excluded, please note here.';
        } else {
            textarea.placeholder = 'Add any special instructions for your order...';
        }
    }

    function updateCGSCheckboxVisibility() {
      fetch('/cart.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
              const cgsCount = cart.items.reduce(function(count, item) {
                  if (item.variant_id.toString() === CONFIG.giftServiceVariantId) {
                      return count + item.quantity;
                  }
                  return count;
              }, 0);

              const cgsWrapper = document.querySelector('.cgs-checkbox-wrapper');
              if (cgsWrapper) {
                  cgsWrapper.style.display = cgsCount > 0 ? 'flex' : 'none';
              }
              updateCheckoutButtonState();
          });
    }

    function updateCheckoutButtonState() {
      const checkoutBtn = document.querySelector('#checkout');
      if (!checkoutBtn) return;

      const termsCheckbox = document.getElementById('terms-checkbox');
      const cgsCheckbox = document.getElementById('cgs-checkbox');
      const cgsWrapper = document.querySelector('.cgs-checkbox-wrapper');

      const termsOk = termsCheckbox && termsCheckbox.checked;
      const cgsVisible = cgsWrapper && cgsWrapper.style.display !== 'none';
      const cgsOk = !cgsVisible || (cgsCheckbox && cgsCheckbox.checked);

      let canCheckout = termsOk && cgsOk && !hasOverCapacity;

      if (canCheckout) {
          checkoutBtn.disabled = false;
          checkoutBtn.classList.remove('checkout-disabled');
          checkoutBtn.title = '';
      } else {
          checkoutBtn.disabled = true;
          checkoutBtn.classList.add('checkout-disabled');

          if (hasOverCapacity) {
              checkoutBtn.title = 'One or more gift boxes exceed capacity limit';
          } else if (!termsOk) {
              checkoutBtn.title = 'Please agree to the Terms and Conditions';
          } else if (!cgsOk) {
              checkoutBtn.title = 'Please acknowledge the Custom Gift Service terms';
          }
      }
    }

    // ============ MODE TOGGLE ============

    function toggleGiftBoxMode() {
        if (giftBoxModeActive) {
            deactivateGiftBoxMode();
        } else {
            activateGiftBoxMode();
        }
    }

    function activateGiftBoxMode() {
        giftBoxModeActive = true;

        const toggleBtn = document.querySelector('.gift-box-toggle-btn');
        if (toggleBtn) {
            toggleBtn.classList.add('active');
            toggleBtn.textContent = 'Cancel Gift Box';
        }

        const cartItemsContainer = document.querySelector('cart-items');
        if (cartItemsContainer) {
            cartItemsContainer.classList.add('gift-box-mode');
        }

        syncCGSQuantity().then(function() {
            splitItemsByQuantity();
            renderSortedCart();
            saveState();
            updateCGSCheckboxVisibility();
            updateCartNotePlaceholder();
        });
    }

    function deactivateGiftBoxMode() {
        removeAllGiftServiceItems().then(function() {
            clearState();
            location.reload();
        });
    }

    // ============ SPLIT ITEMS BY QUANTITY ============

    function splitItemsByQuantity() {
        const cartItems = document.querySelectorAll('.cart-item');

        cartItems.forEach(function(cartItem) {
            const productType = cartItem.dataset.productType || '';

            if (CONFIG.excludedProductTypes.includes(productType)) {
                cartItem.classList.add('gift-box-excluded');
                return;
            }

            cartItem.classList.add('gift-box-original');
            cartItem.style.display = 'none';
        });
    }

    // ============ RENDER SORTED CART ============

    function renderSortedCart() {
        const tbody = document.querySelector('.cart-items tbody');
        if (!tbody) return;

        const existingElements = tbody.querySelectorAll('.gift-box-split-item, .gift-box-info-bar, .gift-box-cgs-item');
        existingElements.forEach(function(el) { el.remove(); });

        const originalItems = tbody.querySelectorAll('.cart-item.gift-box-original');
        const allUnits = [];

        originalItems.forEach(function(cartItem) {
            const productType = cartItem.dataset.productType || '';
            if (CONFIG.excludedProductTypes.includes(productType)) {
                return;
            }

            const lineItemId = cartItem.id;
            const variantId = cartItem.dataset.variantId || cartItem.querySelector('[name="id"]')?.value || lineItemId;
            const quantityInput = cartItem.querySelector('.quantity__input');

            const quantity = parseInt(quantityInput?.value) || 1;
            const capacity = parseInt(cartItem.dataset.capacity) || CONFIG.defaultCapacity;

            for (let i = 0; i < quantity; i++) {
                const unitId = 'variant-' + variantId + '_unit-' + i;
                const boxNumber = boxAssignments[unitId] || 0;

                allUnits.push({
                    unitId: unitId,
                    lineItemId: lineItemId,
                    unitIndex: i,
                    boxNumber: boxNumber,
                    capacity: capacity,
                    originalElement: cartItem
                });
            }
        });

        allUnits.sort(function(a, b) {
            if (a.boxNumber === 0 && b.boxNumber === 0) return 0;
            if (a.boxNumber === 0) return 1;
            if (b.boxNumber === 0) return -1;
            return a.boxNumber - b.boxNumber;
        });

        const boxGroups = {};
        const unboxedItems = [];

        allUnits.forEach(function(unit) {
            if (unit.boxNumber > 0) {
                if (!boxGroups[unit.boxNumber]) {
                    boxGroups[unit.boxNumber] = [];
                }
                boxGroups[unit.boxNumber].push(unit);
            } else {
                unboxedItems.push(unit);
            }
        });

        const allCartItems = tbody.querySelectorAll('.cart-item');
        let cgsTemplate = null;

        allCartItems.forEach(function(item) {
            const productType = item.dataset.productType || '';
            if (productType === 'Service') {
                if (!cgsTemplate) {
                    cgsTemplate = item;
                }
                item.style.display = 'none';
                item.classList.add('gift-box-cgs-original');
            }
        });

        for (var boxNum = 1; boxNum <= boxCount; boxNum++) {
            var items = boxGroups[boxNum] || [];
            var capacity = 0;
            items.forEach(function(item) {
                capacity += item.capacity;
            });

            var infoBar = createInfoBar(boxNum, capacity);
            tbody.appendChild(infoBar);

            if (cgsTemplate) {
                var cgsRow = createCGSRow(cgsTemplate, boxNum);
                tbody.appendChild(cgsRow);
            }

            items.forEach(function(unit, index) {
                var row = createSplitItemRow(unit);
                if (index === items.length - 1) {
                    row.classList.add('box-last-item');
                }
                tbody.appendChild(row);
            });
        }

        unboxedItems.forEach(function(unit) {
            var row = createSplitItemRow(unit);
            tbody.appendChild(row);
        });

        const boxCapacities = {};
        for (var b = 1; b <= boxCount; b++) {
            var boxItems = boxGroups[b] || [];
            var totalCap = 0;
            boxItems.forEach(function(item) {
                totalCap += item.capacity;
            });
            boxCapacities[b] = totalCap;
        }
        updateCapacityWarning(boxCapacities);
    }

    function createInfoBar(boxNumber, currentCapacity) {
        const tr = document.createElement('tr');
        tr.className = 'gift-box-info-bar';
        tr.dataset.boxNumber = boxNumber;

        let capacityClass = '';
        if (currentCapacity >= CONFIG.maxCapacity) {
            capacityClass = 'capacity-error';
        } else if (currentCapacity >= CONFIG.warningThreshold) {
            capacityClass = 'capacity-warning';
        }

        tr.innerHTML = `
            <td colspan="4" class="gift-box-info-bar-cell">
                <div class="gift-box-info-bar-content">
                    <span class="gift-box-info-bar-title">Box #${boxNumber}</span>
                    <span class="gift-box-info-bar-capacity ${capacityClass}">${currentCapacity}/${CONFIG.maxCapacity} capacity</span>
                </div>
            </td>
        `;

        return tr;
    }

    function createCGSRow(originalCGS, boxNumber) {
        const tr = document.createElement('tr');
        tr.className = 'cart-item gift-box-cgs-item';
        tr.dataset.boxNumber = boxNumber;

        const imageCell = originalCGS.querySelector('.cart-item__media');
        const nameEl = originalCGS.querySelector('.cart-item__name');
        const name = nameEl ? nameEl.textContent.trim() : 'Custom Gift Service';
        const href = nameEl ? nameEl.getAttribute('href') : '#';

        tr.innerHTML = `
            <td class="cart-item__media">
                ${imageCell ? imageCell.innerHTML : ''}
            </td>
            <td class="cart-item__details">
                <a href="${href}" class="cart-item__name h4 break">${name}</a>
                <div class="product-option">€5,00</div>
            </td>
            <td class="cart-item__quantity">
                <span class="gift-box-quantity">Qty: 1</span>
            </td>
            <td class="cart-item__totals">
                <span class="price price--end">€5,00</span>
            </td>
        `;

        return tr;
    }

    function createSplitItemRow(unit) {
        const original = unit.originalElement;
        const tr = document.createElement('tr');
        tr.className = 'cart-item gift-box-split-item';
        tr.dataset.unitId = unit.unitId;
        tr.dataset.boxNumber = unit.boxNumber;

        const imageCell = original.querySelector('.cart-item__media');

        tr.innerHTML = `
            <td class="cart-item__media">
                ${imageCell ? imageCell.innerHTML : ''}
            </td>
            <td class="cart-item__details gift-box-split-details">
                <div class="gift-box-split-info">
                    ${getItemBasicInfo(original)}
                </div>
                <div class="gift-box-dropdown-wrapper">
                </div>
            </td>
            <td class="cart-item__quantity gift-box-quantity-cell">
                <span class="gift-box-quantity">Qty: 1</span>
            </td>
            <td class="cart-item__totals">
                <span class="price">${getItemUnitPrice(original)}</span>
            </td>
        `;

        const dropdownWrapper = tr.querySelector('.gift-box-dropdown-wrapper');
        const dropdown = createBoxDropdown(unit.unitId, unit.boxNumber);
        dropdownWrapper.appendChild(dropdown);

        return tr;
    }

    function getItemBasicInfo(original) {
        const nameEl = original.querySelector('.cart-item__name');
        const name = nameEl ? nameEl.textContent.trim() : 'Item';
        const href = nameEl ? nameEl.getAttribute('href') : '#';

        return '<a href="' + href + '" class="cart-item__name h4 break">' + name + '</a>';
    }

    function getItemUnitPrice(original) {
        const priceEl = original.querySelector('.cart-item__details .product-option');
        return priceEl ? priceEl.textContent.trim() : '';
    }

    // ============ BOX SELECTION HANDLING ============

    function handleBoxSelection(event) {
        event.preventDefault();
        event.stopPropagation();

        const select = event.target;
        const unitId = select.dataset.unitId;
        const value = select.value;

        if (value === 'new') {
            if (boxCount >= 3) {
                select.value = '0';
                return;
            }

            boxCount++;
            boxAssignments[unitId] = boxCount;
            saveState();

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: CONFIG.giftServiceVariantId,
                    quantity: 1
                })
            })
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                location.reload();
            })
            .catch(function(error) {
                console.error('Error adding CGS:', error);
                boxCount--;
                delete boxAssignments[unitId];
                saveState();
            });

        } else {
            const boxNumber = parseInt(value);

            if (boxNumber === 0) {
                const oldBox = boxAssignments[unitId];
                delete boxAssignments[unitId];

                const hasItems = Object.values(boxAssignments).includes(oldBox);

                if (!hasItems && oldBox) {
                    fetch('/cart.js')
                        .then(function(response) { return response.json(); })
                        .then(function(cart) {
                            const giftServiceItem = cart.items.find(function(item) {
                                return item.variant_id.toString() === CONFIG.giftServiceVariantId;
                            });

                            if (giftServiceItem && giftServiceItem.quantity > 0) {
                                return fetch('/cart/change.js', {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({
                                        id: CONFIG.giftServiceVariantId,
                                        quantity: giftServiceItem.quantity - 1
                                    })
                                });
                            }
                        })
                        .then(function() {
                            reindexBoxes();
                            saveState();
                            location.reload();
                        });
                } else {
                    saveState();
                    renderSortedCart();
                }
            } else {
                const oldBox = boxAssignments[unitId];
                boxAssignments[unitId] = boxNumber;

                const oldBoxHasItems = Object.values(boxAssignments).includes(oldBox);

                if (!oldBoxHasItems && oldBox && oldBox !== boxNumber) {
                    fetch('/cart.js')
                        .then(function(response) { return response.json(); })
                        .then(function(cart) {
                            const giftServiceItem = cart.items.find(function(item) {
                                return item.variant_id.toString() === CONFIG.giftServiceVariantId;
                            });

                            if (giftServiceItem && giftServiceItem.quantity > 1) {
                                return fetch('/cart/change.js', {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({
                                        id: CONFIG.giftServiceVariantId,
                                        quantity: giftServiceItem.quantity - 1
                                    })
                                });
                            }
                        })
                        .then(function() {
                            reindexBoxes();
                            saveState();
                            location.reload();
                        });
                } else {
                    saveState();
                    renderSortedCart();
                    updateAllDropdowns();
                }
            }
        }
    }

    function reindexBoxes() {
        const usedBoxes = [];
        var vals = Object.values(boxAssignments);
        for (var i = 0; i < vals.length; i++) {
            if (usedBoxes.indexOf(vals[i]) === -1) {
                usedBoxes.push(vals[i]);
            }
        }
        usedBoxes.sort(function(a, b) { return a - b; });

        var mapping = {};
        for (var j = 0; j < usedBoxes.length; j++) {
            mapping[usedBoxes[j]] = j + 1;
        }

        var newAssignments = {};
        for (var unitId in boxAssignments) {
            newAssignments[unitId] = mapping[boxAssignments[unitId]];
        }

        boxAssignments = newAssignments;
        boxCount = usedBoxes.length;
    }

    function syncCGSQuantity() {
        if (boxCount === 0) return Promise.resolve();

        return fetch('/cart.js')
            .then(function(response) { return response.json(); })
            .then(function(cart) {
                const giftServiceItem = cart.items.find(function(item) {
                    return item.variant_id.toString() === CONFIG.giftServiceVariantId;
                });

                const currentQty = giftServiceItem ? giftServiceItem.quantity : 0;

                if (currentQty !== boxCount) {
                    return fetch('/cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            id: CONFIG.giftServiceVariantId,
                            quantity: boxCount
                        })
                    }).then(function() {
                        location.reload();
                    });
                }
            });
    }

    // ============ CART API FUNCTIONS ============

    function removeAllGiftServiceItems() {
        return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: CONFIG.giftServiceVariantId,
                quantity: 0
            })
        }).then(function(response) {
            return response.json();
        });
    }

    // ============ CHECKOUT INTERCEPTION (Cart Note) ============

    function interceptCheckoutButton() {
        const checkoutBtn = document.querySelector('#checkout');

        if (!checkoutBtn) return;

        checkoutBtn.addEventListener('click', function(e) {
            const userNote = document.getElementById('gift-box-user-note')?.value.trim() || '';

            // If no gift box mode and no user note, proceed normally
            if ((!giftBoxModeActive || boxCount === 0) && !userNote) return;

            e.preventDefault();
            e.stopPropagation();

            let noteText = '';

            if (giftBoxModeActive && boxCount > 0) {
                noteText = buildBoxAssignmentNote();
            } else if (userNote) {
                noteText = '=== CUSTOMER NOTE ===\n' + userNote;
            }

            fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ note: noteText })
            })
            .then(function(response) {
                return response.json();
            })
            .then(function() {
                window.location.href = '/checkout';
            })
            .catch(function() {
                window.location.href = '/checkout';
            });
        });
    }

    function buildBoxAssignmentNote() {
        const boxContents = {};
        const userNote = document.getElementById('gift-box-user-note')?.value.trim() || '';

        for (const unitId in boxAssignments) {
            const boxNum = boxAssignments[unitId];
            if (boxNum > 0) {
                if (!boxContents[boxNum]) {
                    boxContents[boxNum] = [];
                }

                const variantId = unitId.split('_unit-')[0].replace('variant-', '');

                const cartItem = document.querySelector('[data-variant-id="' + variantId + '"]');
                const nameEl = cartItem ? cartItem.querySelector('.cart-item__name') : null;
                const baseName = nameEl ? nameEl.textContent.trim() : 'Product ' + variantId;

                // Grab variant option lines (Dawn renders them as .product-option inside
                // .cart-item__details; the last one is the price so we skip it)
                let productName = baseName;
                if (cartItem) {
                    const optionEls = cartItem.querySelectorAll('.cart-item__details .product-option');
                    const variantParts = [];
                    for (let o = 0; o < optionEls.length - 1; o++) {
                        const text = optionEls[o].textContent.trim();
                        if (text) variantParts.push(text);
                    }
                    if (variantParts.length > 0) {
                        productName += ' — ' + variantParts.join(', ');
                    }
                }

                boxContents[boxNum].push(productName);
            }
        }

        let note = '';

        // Add user note first if exists
        if (userNote) {
            note += '=== CUSTOMER NOTE ===\n' + userNote + '\n\n';
        }

        note += '=== GIFT BOX ASSIGNMENTS ===\n\n';

        for (let boxNum = 1; boxNum <= boxCount; boxNum++) {
            const items = boxContents[boxNum] || [];
            note += 'Box #' + boxNum + ':\n';
            if (items.length > 0) {
                const itemCounts = {};
                items.forEach(function(item) {
                    itemCounts[item] = (itemCounts[item] || 0) + 1;
                });

                for (const itemName in itemCounts) {
                    const count = itemCounts[itemName];
                    if (count > 1) {
                        note += '  - ' + itemName + ' (x' + count + ')\n';
                    } else {
                        note += '  - ' + itemName + '\n';
                    }
                }
            } else {
                note += '  (empty)\n';
            }
            note += '\n';
        }

        return note;
    }

    // ============ START ============

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();